import { GenericRequestBody, GenericResponse } from '@omnea-digital/toolbox'
import createClient from 'openapi-fetch'
import { withErrorCapture } from '@omnea-app/packages/universal/general/observability/withErrorCapture'
import { ServiceUrls } from '@omnea-app/packages/universal/general/serviceUrls'
import { paths } from './intakeGeneratedTypes'

interface Params {
  authorization: string
}

export class IntakeHttpClient {
  GET
  POST
  constructor({ authorization }: Params) {
    const { GET, POST } = createClient<paths>({
      baseUrl: ServiceUrls.INTAKES,
      headers: { Authorization: authorization },
    })
    this.GET = withErrorCapture({ method: GET })
    this.POST = withErrorCapture({ method: POST })
  }
}

export type IntakeRequestBody<TPath extends keyof paths, TMethod extends keyof paths[TPath]> = GenericRequestBody<
  paths,
  TPath,
  TMethod
>
export type IntakeResponse<TPath extends keyof paths, TMethod extends keyof paths[TPath]> = GenericResponse<paths, TPath, TMethod>
export type IntakeResponseData<TPath extends keyof paths, TMethod extends keyof paths[TPath]> = NonNullable<
  IntakeResponse<TPath, TMethod>['data']
>
